var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 158,
    viewBox: "0 0 177 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2_1456)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1456)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.9531,
    y: 20,
    width: 138,
    height: 138,
    rx: 69,
    fill: "#D9E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1506 127.359L67.3915 127.359",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.798 68.5321L48.3507 61.8696",
    stroke: "#5E233E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2178 65.4978L59.103 60.166",
    stroke: "#5E233E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2801 72.4581L45.9531 71.5442",
    stroke: "#5E233E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7741 45.0574C88.2032 45.0574 91.6505 48.5992 93.7802 53.2695C95.9136 57.9481 96.6347 63.6006 96.6347 67.3767H98.1347C98.1347 63.463 97.3948 57.5809 95.145 52.6472C92.8915 47.7053 89.0335 43.5574 82.7741 43.5574V45.0574ZM82.7741 43.5574C76.6789 43.5574 72.7867 46.1303 70.4549 49.7563C68.1546 53.3333 67.4136 57.8656 67.4136 61.7839H68.9136C68.9136 58.0125 69.6336 53.8066 71.7165 50.5677C73.7678 47.3778 77.1809 45.0574 82.7741 45.0574V43.5574Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7738 42.75C89.1468 42.75 93.1656 46.7029 95.6317 51.8406C98.1061 56.9958 98.9413 63.2199 98.9413 67.3763H100.441C100.441 63.0738 99.5847 56.6098 96.984 51.1915C94.3748 45.7558 89.9348 41.25 82.7738 41.25V42.75ZM82.7738 41.25C75.7533 41.25 71.2865 44.24 68.6102 48.3735C65.9645 52.4597 65.1063 57.5983 65.1063 61.9062H66.6063C66.6063 57.7554 67.4399 52.9409 69.8693 49.1887C72.2683 45.4837 76.2602 42.75 82.7738 42.75V41.25Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6295 69.5469C59.6687 69.5469 55.6471 73.5684 55.6471 78.5292V107.269C55.6471 112.23 59.6687 116.251 64.6295 116.251H100.325C105.286 116.251 109.307 112.23 109.307 107.269V78.5292C109.307 73.5684 105.286 69.5469 100.325 69.5469H64.6295ZM87.4436 87.438C87.4436 89.3658 86.3456 91.0372 84.7408 91.861L87.2506 101.596C87.3483 101.975 87.0622 102.344 86.6708 102.344H78.2793C77.8879 102.344 77.6017 101.975 77.6994 101.596L80.2092 91.861C78.6045 91.0372 77.5065 89.3658 77.5065 87.438C77.5065 84.6939 79.731 82.4694 82.475 82.4694C85.2191 82.4694 87.4436 84.6939 87.4436 87.438Z",
    fill: "url(#paint0_linear_2_1456)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.69252,
    y: 96.5549,
    width: 7.56076,
    height: 10.4943,
    rx: 3.78038,
    transform: "rotate(-10.0805 2.69252 96.5549)",
    stroke: "#743250",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3075 99.451L33.4039 95.659",
    stroke: "#743250",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2278 100.437L31.667 96.2989",
    stroke: "#743250",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.979 114.9C150.979 114.9 147.237 109.943 150.593 104.542C150.593 104.542 154.282 106.218 154.725 107.611C154.725 107.611 152.11 112.83 157.382 118.253C157.354 118.255 152.468 116.566 150.979 114.9Z",
    fill: "url(#paint1_linear_2_1456)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.361 124.132C167.361 124.132 158.199 125.449 150.985 114.908C150.985 114.908 159.319 120.346 164.501 117.593C164.499 117.565 167.595 120.528 167.361 124.132Z",
    fill: "#73314F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8724 9.63527C39.8724 9.63527 42.6915 6.21115 46.9882 7.64781C46.9882 7.64781 46.4195 10.4828 45.5377 11.0313C45.5377 11.0313 41.4867 10.0571 38.5754 14.6192C38.5952 14.618 38.9555 10.9409 39.8724 9.63527Z",
    fill: "url(#paint2_linear_2_1456)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.152 22.5323C36.152 22.5323 33.7254 16.3961 39.8657 9.63762C39.8657 9.63762 37.4759 16.3149 40.2442 19.4706C40.2233 19.452 38.6901 22.1051 36.152 22.5323Z",
    fill: "#73314F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9127 25.5321C83.9127 25.5321 83.5347 24.0223 85.0467 21.6525C85.0467 21.6525 86.4637 21.4332 87.1742 21.6468C87.8856 21.8774 89.0501 22.2856 88.9203 22.6848C88.7736 23.0849 88.1538 24.415 88.0588 25.6972C87.9639 26.9795 86.9262 25.8318 85.8166 26.0672C84.689 26.2866 83.9386 26.2626 83.9127 25.5321Z",
    fill: "#89AAAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.013 24.3138C135.013 24.3138 134.279 21.385 137.213 16.7881C137.213 16.7881 139.961 16.3626 141.339 16.777C142.72 17.2243 144.978 18.0162 144.727 18.7905C144.442 19.5667 143.24 22.1468 143.056 24.6341C142.871 27.1214 140.859 24.8952 138.706 25.3518C136.553 25.8083 135.096 25.7288 135.013 24.3138Z",
    fill: "url(#paint3_linear_2_1456)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 78.2148C143.26 78.2148 142.301 74.3827 146.138 68.368C146.138 68.368 149.735 67.8112 151.538 68.3534C153.344 68.9387 156.299 69.9749 155.97 70.988C155.598 72.0035 154.024 75.3794 153.783 78.6339C153.542 81.8883 150.909 78.9754 148.092 79.5728C145.273 80.1271 143.369 80.0662 143.26 78.2148Z",
    fill: "#4F7D7D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.894 59.0095C164.894 59.0095 165.864 57.192 169.449 56.1989C169.449 56.1989 171.05 57.2298 171.54 58.0814C172.03 58.9329 172.824 60.378 172.327 60.6517C171.829 60.9255 170.039 61.6664 168.787 62.8403C167.56 64.0128 167.537 61.96 166.27 61.203C164.98 60.4717 164.278 59.7549 164.894 59.0095Z",
    fill: "#4F7D7D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.863 7.93251C105.863 7.93251 108.503 5.01122 115.569 4.86847C115.569 4.86847 118.038 7.53512 118.551 9.31897C119.064 11.1028 119.877 14.1388 118.806 14.4285C117.78 14.7155 114.092 15.2494 111.282 16.8202C108.472 18.391 109.384 14.6188 107.364 12.6514C105.341 10.6387 104.384 9.01698 105.863 7.93251Z",
    fill: "#4F7D7D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.436 34.6586C159.436 34.6586 160.427 33.5621 163.079 33.5085C163.079 33.5085 164.006 34.5095 164.199 35.1791C164.391 35.8486 164.697 36.9882 164.294 37.097C163.909 37.2047 162.525 37.4051 161.47 37.9947C160.416 38.5843 160.758 37.1684 160 36.4299C159.24 35.6744 158.881 35.0657 159.436 34.6586Z",
    fill: "#73314F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2666 32.2608C52.2666 32.2608 54.3391 31.5723 57.798 33.4306C57.798 33.4306 58.2736 35.3868 58.0243 36.4064C57.8006 37.4245 57.3321 39.1011 56.7551 38.9289C56.1796 38.7823 54.2553 38.0449 52.4759 38.0205C50.698 38.0219 52.1528 36.4677 51.7285 34.9465C51.2785 33.4268 51.2424 32.3725 52.2666 32.2608Z",
    fill: "url(#paint4_linear_2_1456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2_1456",
    x: 11.9531,
    y: 20,
    width: 138,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_1456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1456",
    x1: 69.09,
    y1: 80.624,
    x2: 84.3162,
    y2: 115.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275C61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1456",
    x1: 157.382,
    y1: 118.253,
    x2: 149.861,
    y2: 104.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1456",
    x1: 47.3672,
    y1: 14.103,
    x2: 45.2296,
    y2: 5.85085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1456",
    x1: 145.157,
    y1: 25.6609,
    x2: 141.916,
    y2: 14.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1456",
    x1: 58.2933,
    y1: 38.8562,
    x2: 55.653,
    y2: 30.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1456"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.9531,
    y: 20,
    width: 138,
    height: 138,
    rx: 69,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome1);
export default __webpack_public_path__ + "static/media/welcome1.874e5fc3660ce3058a08a14d388125e0.svg";
export { ForwardRef as ReactComponent };